import * as React from "react";

import { TableCell, TableRow } from "@mui/material";
import { t } from "i18next";
import { FeatureToggle, IsFeatureToggleEnabled } from "../../../../helpers/is-feature-toggle-enabled";

export const AreaListSubLine = () => {

    const renderColumnSort = (labelKey: string, fieldName: string, colSpan?: number) => {
        return <TableCell className="cellHeader" colSpan={colSpan} data-testid={`column-lvl2-${fieldName}`}>
            {t(labelKey)}
        </TableCell>;
    };

    return <TableRow className="level2 header">
        <TableCell />
        {renderColumnSort("model.areaDetail.productId", "details.productId")}
        {renderColumnSort("model.areaDetail.ean13List", "details.ean13List")}
        {renderColumnSort("model.areaDetail.supplierReference", "details.supplierReference")}
        {renderColumnSort("model.areaDetail.labelReference", "details.labelReference", 2)}
        {renderColumnSort("model.areaDetail.quantityParcelled", "details.quantityParcelled")}
        {renderColumnSort("model.areaDetail.quantityAvailable", "details.quantityAvailable")}
        {IsFeatureToggleEnabled(FeatureToggle.STOCKOUTS) &&
            renderColumnSort("model.areaDetail.quantityStockout", "details.quantityStockout")}
        {renderColumnSort("model.areaDetail.weight", "details.weight")}
    </TableRow>;
};
